import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import Regsugarcanelist from "../Regsugarcane/Regsugarcanelist";
import Regsugarcanedata from "../Regsugarcane/Regsugarcanedata";

function Regsugarcanetab() {
  return (
    <>
      <Tabs
        defaultActiveKey="regsugarcanelist"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="regsugarcanelist" title="จดทะเบียนชาวไร่อ้อย">
          <Regsugarcanelist />
        </Tab>
        <Tab eventKey="regsugarcanedata" title="ข้อมูลชาวไร่อ้อย">
          <Regsugarcanedata />
        </Tab>
      </Tabs>
    </>
  );
}

export default Regsugarcanetab;
